@if (mainItem?.htmlElementType === 'link') {
  <a
    class="cc-nba-secondary-item__button"
    [href]="mainItem?.href$ | async"
    [ccTrackClick]="{ action: mainItem['trackingPosition'], label: mainItem['trackingLinkName'], category: 'link' }"
    (click)="onMainItemClick($event, mainItem)"
    target="_blank"
    rel="noopener"
  >
  </a>
}

@if (mainItem?.htmlElementType === 'button') {
  <ccwb-link
    class="cc-nba-secondary-item__button"
    [ccTrackClick]="{ action: mainItem['trackingPosition'], label: mainItem['trackingLinkName'], category: 'link' }"
    (click)="onMainItemClick($event, mainItem)"
    variant="standalone"
    size="l"
  >
    <ng-container *ngTemplateOutlet="nbaInner; context: { mainItem: mainItem }" />
  </ccwb-link>
}

<ng-template #nbaInner>
  @if (mainItem?.icon) {
    <ccwb-icon
      class="cc-nba-secondary-item__button-icon--large cc-nba-secondary-item__button-icon--without-space"
      name="{{ mainItem?.icon }}"
      slot="icon"
    />
  }
  @if (mainItem?.customWidget) {
    <div class="cc-nba-secondary-item__button-icon-widget">
      <ng-container
        *ngTemplateOutlet="
          customWidgetContainerTemplateRef;
          context: {
            customWidget: mainItem.customWidget,
            saveLabel: mainItem.label,
            savedLabel: mainItem.savedToAccountLabel
          }
        "
      />
    </div>
  }
  {{ mainItem?.label | translate: returnTranslationOrKey }}
  <ng-container *ngTemplateOutlet="footnoteHintsTemplateRef; context: { footnoteHints: mainItem?.footnoteHints }"
/></ng-template>
